import IntersectionObserver from 'intersection-observer'; // polyfill of IntersectionObserver
import Lozad from 'lozad';

const observer = Lozad('.lozad', {
  enableAutoReload: true
});
observer.observe();
